import {PlayableAction, PlayerReduxState} from "../types";
import getCurrentScenario from "./getCurrentScenario";

export default function getBackFromAction(state: PlayerReduxState, index?: number): PlayableAction | null {
  if (index === undefined) {
    index = state.index;
  }

  for (let i = index - 1; i > 0; i--) {
    return getCurrentScenario(state).actions[i];
  }

  return getCurrentScenario(state).actions[0] ?? null;
}
